import React, { useEffect } from "react";
import HeaderOne from "../common/header/Header";
import Breadcrumb from "../common/breadcrumb/Breadcrumb";
import ContactForm from "../components/contact/ContactForm";
import ContactInfo from "../components/contact/ContactInfo";
import ContactMap from "../components/contact/ContactMap";
import Footer from "../common/footer/Footer";
import { useLocation } from "react-router-dom";
import SEO from "../common/seo/SEO";

const Contact = () => {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <>
      <SEO path={"/contact"} prefix={"Contact Us"} />
      <HeaderOne />
      <Breadcrumb heading="Contact Us" currentPage="Contact" />
      <ContactForm />
      <ContactInfo />
      <ContactMap />
      <Footer showmap={false} />
    </>
  );
};

export default Contact;
